module.exports = __webpack_public_path__ + "img/banner-34.096d1a93.jpg";